import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRequests, getRequest, deleteRequest } from "../../api/webServices";
import { deleteRequestAction, setActualRequest, setRequestMode, setRequestsList } from "../../store/reducers/requestsSlice";
import ItemsTable from "../ItemsTable";
import { CiSearch } from 'react-icons/ci';
import './Requests.css';

const Requests = () => {

    const { requestsList } = useSelector(state => state.requests);
    const [filteredRequests, setFilteredRequests] = useState([]);
    const ref = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        // Cargar requests
        getRequests().then(res => dispatch(setRequestsList(res?.data)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddNewRequest = async () => {
        dispatch(setRequestMode('new'));
        navigate('/request');
    }

    const handleEditRequest = async (id) => {
        getRequest(id).then(res => {
            dispatch(setRequestMode('update'));
            dispatch(setActualRequest(res?.data));
            navigate('/request');
        }).catch(err => {
            console.log(err);
        });
    }

    const handleViewRequest = async (id) => {
        getRequest(id).then(res => {
            dispatch(setRequestMode('view'));
            dispatch(setActualRequest(res?.data));
            navigate('/request');
        }).catch(err => {
            console.log(err);
        });
    }

    const handleFilterRequest = () => {
        let id = ref.current.value;
        if (id === "") {
            setFilteredRequests([]);
        } else {
            let filtered = requestsList.filter(request => request.id === parseInt(id));
            setFilteredRequests(filtered);
        }
    }

    const handleDeleteRequest = (id) => {
        deleteRequest({ id }).then(res => {
            dispatch(deleteRequestAction(id));
        }).catch(err => {
            console.log(err);
        }
        );
    }

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-20">
            <div className="w-[85%] bg-white h-[90%] my-auto rounded-2xl">
                <h2 className="2xl:py-8 2xl:leading-[75px] text-[30px] 2xl:text-[40px] mt-7 titleRequests">Solicitudes</h2>
                <div className="2xl:w-[65%] w-[80%] mx-auto mt-10">
                    <div className="flex flex-row items-center gap-3">
                        <button className="mx-5 newRequestButton" onClick={handleAddNewRequest}>+ Crear Solicitud</button>
                        <div className="searchRequestContainer">
                            <p>Ingrese ID:</p>
                            <input ref={ref} type="text" className="searchRequestInput">
                            </input>
                            <button className="searchRequestButton" onClick={handleFilterRequest}><CiSearch size={24} /></button>
                        </div>
                    </div>
                    <ItemsTable
                        type="requests"
                        data={filteredRequests?.length > 0 ? filteredRequests : requestsList}
                        handleEdit={handleEditRequest}
                        handleView={handleViewRequest}
                        handleDelete={handleDeleteRequest}
                    />
                </div>
            </div>
        </div>
    )
}

export default Requests;